import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestACHPayout } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, GetCustomerInfo, GetCountries, GetStatesbyCountry } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';

export const PayoutACHMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [arrayCountries, setArrayCountries] = useState([]);
    const [arrayStates, setArrayStates] = useState([]);
    const [stateCode, setStateCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [othForm, setOthForm] = useState({ CheckTypes: '' });
    const CheckTypes = [{ key: 1, text: 'Personal Checking', value: '200510' }, { key: 2, text: 'Personal Savings', value: '200520' },];
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(async function (response) {
            await GetCountries(getClientItem('Token')).then(async function (response) {
                var i = 0;
                const filtered = response.Authentication.map(item => {
                    const {
                        Code,
                        Name } = item;

                    return { Key: i++, Code, Name }
                });
                setArrayCountries(filtered);
                setCountryCode('US');
                handleStatebyCountry('US', true);
            });
        })
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }
        CustomerInfo();

    }, [])

    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription != "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {

                Alerts.ShowAlert('Error', 'Error getting customer info: ' + response.Authentication.ErrorDescription, 'error');

            }
        })
            .catch(function (error) {

                Alerts.ShowAlert('Error', 'Error getting customer info: ' + error.response.data.Authentication.ErrorDescription, 'error');
            })
    }

    const handleStatebyCountry = async (selectedCountryCode, setState) => {
        await GetStatesbyCountry(selectedCountryCode).then(async function (response) {
            var i = 0;
            const filtered = response.Authentication.map(item => {
                const {
                    Code,
                    Name } = item;

                return { Key: i++, Code, Name }
            });
            setArrayStates(filtered);
            if (setState) {
                if (filtered.length > 1)
                    setStateCode(filtered[1].Code);
                else
                    setStateCode(filtered[0].Code);
            }
        })
    }
    async function doRequestACHPayout(Amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) < parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "IPv4Address": clientInfo.IPAddress,
                "Comments": '',
                "BankName": bankname,
                "BankCity": bankcity,
                "BankState": bankstate,
                "CheckAccountNumber": accountnumber,
                "CheckRoutingNumber": routingnumber,
                "CheckAccountName": firstname + lastname,
                "CheckAccountState": stateCode,
                "CheckAccountType": accountType,

            };

            await RequestACHPayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                }
            }).catch(function (error) {
                    Alerts.ShowAlert('Withdrawal Status', error.response.data.Authentication.HtmlResponse, 'error');
                    //Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
            else
                Alerts.ShowAlert('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestACHPayout(amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address);
                setIsProcessing(false);


            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">Withdraw using {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row">                    
                    {/*Account Number*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="accountnumber" className="col-sm-12">Account Number:</label>
                        <input type="text" className="form-control" id="accountnumber" aria-describedby="lblAddress" placeholder="Account Number" name="accountnumber" required="required" />
                    </div>
                    {/*Rounting Number*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="routingnumber" className="col-sm-12">Rounting Number:</label>
                        <input type="text" className="form-control" id="routingnumber" aria-describedby="lblAddress" placeholder="9 digit Routing (ABA)" name="routingnumber" maxLength="9" required="required" />
                    </div>
                    {/*Amount*/}
                    <div className="col-md-4 col-sm-12 m3">
                        <label for="ccCurrency" className="col-sm-12">Amount:</label>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">Currency</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Amount" max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0}/>
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center" style={{ marginBottom: '4px' }}>
                            PayoutLimits: Minimum {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD Maximum {arrayPayouts?.MaxPayout === 0 ? 'No Limit' : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                    {/* Account Type */}
                    <div className="col-md-4 col-sm-12 mb-5">
                        <label for="accountType" className="col-sm-12">Account Type:</label>
                        <select className="form-select border-teal" value="200510" id="accountType" name="accountType"
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Account Type" required >
                            {CheckTypes.map((item) => <option key={item.Key} value={item.value}>{item.text}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-title-color mb-4">
                        <h3>Bank information</h3>
                    </div>
                </div>
                <div className="row">
                    {/*Bank Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankname" className=" col-sm-12">Bank name:</label>
                        <input type="text" className="form-control" id="bankname" aria-describedby="bankname" placeholder="bank name" name="bankname" required="required" />
                    </div>
                    {/*Bank Number*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="banknumber" className=" col-sm-12">Bank number:</label>
                        <input type="text" className="form-control" id="banknumber" aria-describedby="banknumber" placeholder="bank number" name="banknumber" required="required" />
                    </div>

                    {/*<div className="col-md-4 col-sm-12 mb-3">*/}
                    {/*    <label for="bankcountry" className="col-sm-12">Bank Country:</label>*/}
                    {/*    <select className="form-select border-teal" value={countryCode} onChange={(event) => { setCountryCode(event.target.value); handleStatebyCountry(event.target.value, true) }}*/}
                    {/*        tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the Country" required disabled>*/}
                    {/*        {arrayCountries.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>*/}
                    {/*        )}*/}
                    {/*    </select>*/}
                    {/*</div>*/}
                    {/*Bank State*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankstate" className=" col-sm-12">Bank State:</label>
                        <select id="bankstate" name="bankstate" className="form-select border-teal" value={stateCode} onChange={(event) => setStateCode(event.target.value)}
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the State" required>
                            {arrayStates.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                            )}
                        </select>
                    </div>
                    {/*Bank City*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankcity" className=" col-sm-12">Bank City:</label>
                        <input type="text" className="form-control" id="bankcity" aria-describedby="bankcity" placeholder="bank city" name="bankcity" required="required" />
                    </div>
                </div>
                <div className="row">
                    
                    {/*<div className="col-md-8 col-sm-12 mb-3">*/}
                    {/*    <label for="bankaddress" className=" col-sm-12">Bank Address:</label>*/}
                    {/*    <input type="text" className="form-control" id="bankaddress" aria-describedby="bankaddress" placeholder="bank address" name="bankaddress" required="required" />*/}
                    {/*</div>*/}

                </div>
                <div className="row">
                    <div className="col-12 text-title-color mt-4 mb-4">
                        <h3>Personal information</h3>
                    </div>
                </div>
                <div className="row">
                    {/*First Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="firstname" className=" col-sm-12">First Name:</label>
                        <input type="text" className="form-control" id="firstname" aria-describedby="firstname" placeholder="first name" name="firstname" required="required" value={arrayCustomerInfo.Name} />
                    </div>
                    {/*Last Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="lastname" className="col-sm-12">Last name:</label>
                        <input type="text" className="form-control" id="lastname" aria-describedby="lastname" placeholder="last name" name="lastname" required="required" value={arrayCustomerInfo.LastName} />
                    </div>
                    {/*<div className="col-md-4 col-sm-12 mb-3">*/}
                    {/*    <label for="email" className=" col-sm-12">Email:</label>*/}
                    {/*    <input type="email" className="form-control" id="email" aria-describedby="email" placeholder="email" name="email" required="required" value={arrayCustomerInfo.Email} />*/}
                    {/*</div>*/}
                </div>
                <div className="row">
                    {/*<div className="col-md-4 col-sm-12 mb-3">*/}
                    {/*    <label for="telephone" className=" col-sm-12">Phone #:</label>*/}
                    {/*    <input type="number" className="form-control" id="telephone" aria-describedby="telephone" placeholder="phone #" name="telephone" required="required" value={arrayCustomerInfo.Phone} />*/}
                    {/*</div>*/}
                    {/*Country*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="country" className="col-sm-12">Country:</label>
                        <input type="text" className="form-control color-gray border-teal" name="country" aria-label="country" value={arrayCustomerInfo.Country} placeholder={arrayCustomerInfo.Country == '' ? "Country" : arrayCustomerInfo.Country} disabled="disabled" />
                    </div>
                   {/*State*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="state" className=" col-sm-12">State:</label>
                        <input type="text" className="form-control color-gray border-teal" name="state" aria-label="state" value={arrayCustomerInfo.State} placeholder={arrayCustomerInfo.State == '' ? "State / Prov" : arrayCustomerInfo.State} disabled="disabled" />
                    </div>
                </div>
                {/*<div className="row">*/}
                {/*    <div className="col-md-4 col-sm-12 mb-3">*/}
                {/*        <label for="city" className=" col-sm-12">City:</label>*/}
                {/*        <input type="text" className="form-control" id="city" aria-describedby="city" placeholder="city" name="city" required="required" value={arrayCustomerInfo.City} />*/}
                {/*    </div>*/}

                {/*    <div className="col-md-4 col-sm-12 mb-3">*/}
                {/*        <label for="zipcode" className="col-sm-12">Zipcode:</label>*/}
                {/*        <input type="text" className="form-control" id="zipcode" aria-describedby="zipcode" placeholder="zipcode" name="zipcode" required="required" value={arrayCustomerInfo.ZipCode} />*/}
                {/*    </div>*/}
                {/*    <div className="col-md-4 col-sm-12 mb-3">*/}
                {/*        <label for="address" className=" col-sm-12">Address:</label>*/}
                {/*        <input type="text" className="form-control" id="address" aria-describedby="address" placeholder="address" name="address" required="required" value={arrayCustomerInfo.Address} />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">SUBMIT</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}